
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Privateresortinnagpurdistricwithswimmingpool() {



  const cardData =
  {
    keyword: ' Private Resort in Nagpur District with Swimming Pool',
    heading:  'Woodland Escape: Private Resort in Nagpur District with Swimming Pool ',
    headingDescription: 'Woodland Escape Resort is an ideal private resort in Nagpur District with swimming pool, offering a serene retreat where you can enjoy nature and comfort in one place. Located amidst lush greenery and forested surroundings, the resort features a dedicated pool area for guests to unwind, surrounded by verdant lawns and tree-lined vistas that provide privacy and a calm atmosphere. With comfortable cottages, secluded spots, and attentive service, Woodland Escape Resort blends the luxury of a private getaway with the tranquility of nature — making it an excellent option for couples, families or small groups seeking a refreshing escape.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Private Resort in Nagpur District with Swimming Pool",
      "description": "Experience ultimate privacy and relaxation at this private resort in Nagpur district featuring a sparkling swimming pool. Ideal for families, couples, and groups, the resort offers spacious villas, scenic surroundings, and modern amenities. Guests can enjoy poolside lounging, outdoor activities, riverside walks, and evening bonfires, making it a perfect destination for a luxurious and rejuvenating stay."
    },
    {
      "name": "Nagpur Pool Resort Stay",
      "description": "Nagpur Pool Resort Stay combines comfort, luxury, and leisure with a beautiful swimming pool at the heart of the property. Guests can relax in private poolside cabanas, enjoy water games, and indulge in outdoor dining experiences. Surrounded by lush greenery, this resort is perfect for weekend getaways, family outings, and romantic escapes."
    },
    {
      "name": "Nagpur Luxury Private Resort with Pool",
      "description": "This luxury private resort offers world-class amenities and a large swimming pool for ultimate relaxation. With elegantly designed rooms, private villas, and scenic views, guests can unwind in style. The resort also provides spa services, adventure activities, and curated outdoor experiences, making it perfect for couples, families, and group vacations."
    },
    {
      "name": "Nagpur Family Resort with Pool",
      "description": "Designed for family fun, Nagpur Family Resort with Pool offers safe and spacious accommodations, a kid-friendly swimming pool, and outdoor play areas. Families can enjoy picnic spots, nature trails, riverside walks, and group activities, ensuring a memorable stay for all ages. The resort combines comfort, recreation, and scenic beauty for a perfect family weekend."
    },
    {
      "name": "Nagpur Private Villa Resort",
      "description": "Stay in exclusive private villas at Nagpur Private Villa Resort, each with a private swimming pool and serene surroundings. Guests can enjoy a combination of privacy and luxury, along with outdoor dining, nature walks, and adventure activities. Ideal for couples, families, and friends seeking a tranquil getaway in Nagpur."
    },
    {
      "name": "Nagpur Weekend Resort with Swimming Pool",
      "description": "Escape the city hustle with a weekend stay at Nagpur Weekend Resort with Swimming Pool. Guests can relax in modern rooms, take refreshing dips in the pool, enjoy riverside picnics, or explore nearby scenic spots. Weekend packages are designed for families, couples, and friends seeking a refreshing short trip."
    },
    {
      "name": "Nagpur Couple Resort with Pool",
      "description": "Perfect for romantic getaways, Nagpur Couple Resort with Pool offers private poolside villas, cozy accommodations, and scenic surroundings. Couples can enjoy candlelight dinners by the pool, evening bonfires, and intimate nature walks. The resort provides a blend of privacy, luxury, and natural beauty for an unforgettable experience."
    },
    {
      "name": "Nagpur Eco-Friendly Pool Resort",
      "description": "Experience sustainable luxury at Nagpur Eco-Friendly Pool Resort, designed with eco-conscious practices and a beautiful swimming pool. Guests can enjoy nature trails, riverside activities, and poolside relaxation while staying in eco-friendly accommodations. Ideal for couples, families, and groups who value comfort and sustainability."
    },
    {
      "name": "Nagpur Riverside Pool Resort",
      "description": "Stay at Nagpur Riverside Pool Resort to enjoy a swimming pool with stunning river views. Guests can partake in boating, riverside picnics, poolside lounging, and guided nature walks. The resort offers cozy accommodations, outdoor activities, and scenic spots for photography, making it perfect for romantic escapes and family vacations."
    },
    {
      "name": "Nagpur Hill Private Resort",
      "description": "Nestled in the hills, Nagpur Hill Private Resort offers panoramic views, private pool access, and serene surroundings. Guests can enjoy hill treks, nature walks, and poolside relaxation. The resort is perfect for families, couples, and groups seeking a blend of adventure, tranquility, and luxury in a scenic hilltop setting."
    },
    {
      "name": "Nagpur Private Booking Resort",
      "description": "Nagpur Private Booking Resort allows guests to book exclusive villas and pools for complete privacy. Ideal for family reunions, group outings, or romantic retreats, the resort offers modern amenities, outdoor activities, and poolside leisure. Personalized services ensure a seamless and luxurious stay experience."
    },
    {
      "name": "Nagpur Outdoor Activity Resort",
      "description": "Combine relaxation and adventure at Nagpur Outdoor Activity Resort, featuring a swimming pool, trekking trails, and recreational activities. Guests can enjoy pool games, river walks, cycling, and nature exploration. The resort is designed for families, couples, and groups seeking both fun and serenity in natural surroundings."
    },
    {
      "name": "Nagpur Luxury Stay with Pool",
      "description": "Indulge in luxury at Nagpur Luxury Stay with Pool, offering elegantly designed rooms, private villas, and a sparkling swimming pool. Guests can enjoy fine dining, spa services, outdoor adventures, and scenic views. The resort is perfect for couples, families, and groups seeking an opulent getaway amidst nature."
    },
    {
      "name": "Nagpur One Day Pool Resort",
      "description": "Nagpur One Day Pool Resort is perfect for a short getaway or day outing with family and friends. Guests can enjoy swimming, poolside meals, recreational activities, and guided nature walks. This resort offers convenience, comfort, and a refreshing escape for anyone looking for a quick break from city life."
    },
    {
      "name": "Nagpur Scenic Private Pool Resort",
      "description": "Set amidst scenic landscapes, Nagpur Scenic Private Pool Resort offers a private pool, lush surroundings, and luxurious accommodations. Guests can relax by the pool, explore nature trails, enjoy riverside picnics, and partake in adventure activities. Ideal for couples, families, and groups seeking a blend of privacy, comfort, and scenic beauty."
    }
  ],
  "tableData": [
    ["- Private Resort in Nagpur District with Swimming Pool", "- Nagpur Pool Resort Stay"],
    ["- Nagpur Luxury Private Resort with Pool", "- Nagpur Family Resort with Pool"],
    ["- Nagpur Private Villa Resort", "- Nagpur Weekend Resort with Swimming Pool"],
    ["- Nagpur Couple Resort with Pool", "- Nagpur Eco-Friendly Pool Resort"],
    ["- Nagpur Riverside Pool Resort", "- Nagpur Hill Private Resort"],
    ["- Nagpur Private Booking Resort", "- Nagpur Outdoor Activity Resort"],
    ["- Nagpur Luxury Stay with Pool", "- Nagpur One Day Pool Resort"],
    ["- Nagpur Scenic Private Pool Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Private Luxury Resort with Pool in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene and private retreat in Nagpur District, featuring a sparkling swimming pool. Surrounded by lush greenery and tranquil forested landscapes, it’s ideal for guests seeking relaxation and exclusivity."
  },
  {
    "WhyChooseheading": "Refreshing Swimming Pool Experience",
    "WhyChoosedescription": "The resort features a well-maintained swimming pool where guests can unwind, swim, or lounge poolside. Perfect for families, couples, or groups, it provides a refreshing escape in a scenic natural setting."
  },
  {
    "WhyChooseheading": "Private and Comfortable Accommodation",
    "WhyChoosedescription": "Woodland Escape Resort offers spacious rooms and cottages designed for comfort and privacy. Each unit combines modern amenities with forest views, allowing guests to enjoy both luxury and the beauty of nature."
  },
  {
    "WhyChooseheading": "Lush Natural Surroundings",
    "WhyChoosedescription": "The resort is enveloped by mature trees, gardens, and walking trails. Guests can enjoy leisurely strolls, breathe in fresh air, and experience the soothing ambience of nature while staying close to the pool and other facilities."
  },
  {
    "WhyChooseheading": "Fun and Relaxation for All Ages",
    "WhyChoosedescription": "Alongside the swimming pool, Woodland Escape offers outdoor spaces, nature trails, and recreational activities suitable for families, couples, and groups. Everyone can find activities that match their mood and energy levels."
  },
  {
    "WhyChooseheading": "Gourmet Meals and Refreshments",
    "WhyChoosedescription": "Guests can enjoy freshly prepared local and continental meals while relaxing near the pool or in the dining area. The resort ensures every stay is not just comfortable but also gastronomically satisfying."
  },
  {
    "WhyChooseheading": "Easily Accessible Yet Secluded",
    "WhyChoosedescription": "Located within easy reach of Nagpur city, Woodland Escape Resort combines accessibility with the feeling of a private, forested retreat. Guests can enjoy an exclusive getaway without traveling far."
  }
]





























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a private resort with swimming pool in Nagpur district?",
    answer: "Woodland Escape Resort offers a tranquil, exclusive stay in Nagpur district, complete with a dedicated swimming pool—perfect for guests who want both privacy and recreation around water."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort lies within comfortable driving distance from Nagpur city, making it accessible yet secluded—so you enjoy poolside privacy without being too far from the city."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for a private stay with a pool?",
    answer: "The resort features a well‑maintained swimming pool, poolside loungers, private or semi‑private room/cottage options overlooking the pool or nature, open lawns, children’s zone, and calm surroundings for relaxation."
  },
  {
    question: "Is Woodland Escape Resort suitable for couples, families or groups wanting a private pool stay?",
    answer: "Yes! The resort caters to families, couples or groups looking for a peaceful stay with pool access, offering enough space, safe surroundings, and amenities that ensure everyone can unwind comfortably."
  },
  {
    question: "Does the resort provide meals and other services for guests staying with swimming pool access?",
    answer: "Yes—Woodland Escape Resort offers freshly prepared meals, snacks, beverages, and additional services such as poolside tea/coffee, perhaps poolside views from rooms, making your stay convenient and luxurious."
  },
  {
    question: "How can we book Woodland Escape Resort for a private pool stay in Nagpur district?",
    answer: "You can book through calling or WhatsApp messaging their reservation team, or via the official website. It’s advised to book in advance—especially pool‑view rooms/cottages and during weekends/holidays."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Patel, Nagpur",
    text: "Our stay at Woodland Escape Resort was fantastic! The room by the pool, the quiet surroundings and the pool access made our weekend truly special. Perfect private resort experience in Nagpur district."
  },
  {
    name: "Ms. Anita & Family, Nagpur",
    text: "We picked Woodland Escape Resort for a pool‑stay getaway and loved it. The kids had fun in the pool, the adults relaxed in nature, and the service was top‑notch. Highly recommended!"
  }
];
































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Private Resort in Nagpur District with Swimming Pool",
  "image": "https://woodlandescape.com/assets/images/nagpur-private-pool-resort.jpg",
  "description": "Experience luxury and privacy at our Nagpur Pool Resort Stay. Perfect for families, couples, or weekend getaways, featuring eco-friendly villas, hilltop and riverside views, and a sparkling swimming pool for relaxation and fun.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "42"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-private-pool-resort"
  }
};




  return (
    <div>
<Helmet>
  <title>Private Resort in Nagpur District with Swimming Pool | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a luxurious private stay at Nagpur Pool Resort with swimming pool, eco-friendly villas, riverside and hilltop views, perfect for families, couples, and weekend getaways." 
  />
  <meta 
    name="keywords" 
    content="Private Resort in Nagpur District with Swimming Pool, Nagpur Pool Resort Stay, Nagpur Luxury Private Resort with Pool, Nagpur Family Resort with Pool, Nagpur Private Villa Resort, Nagpur Weekend Resort with Swimming Pool, Nagpur Couple Resort with Pool, Nagpur Eco-Friendly Pool Resort, Nagpur Riverside Pool Resort, Nagpur Hill Private Resort, Nagpur Private Booking Resort, Nagpur Outdoor Activity Resort, Nagpur Luxury Stay with Pool, Nagpur One Day Pool Resort, Nagpur Scenic Private Pool Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/52.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Privateresortinnagpurdistricwithswimmingpool;